var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGalleryIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 2H6.66634C4.15218 2 2.89511 2 2.11405 2.78105C1.33301 3.5621 1.33301 4.81917 1.33301 7.33333V8.66667C1.33301 11.1808 1.33301 12.4379 2.11405 13.2189C2.89511 14 4.15218 14 6.66634 14H9.33301C11.8471 14 13.1043 14 13.8853 13.2189C14.6663 12.4379 14.6663 11.1808 14.6663 8.66667V7.33333C14.6663 4.81917 14.6663 3.5621 13.8853 2.78105C13.1043 2 11.8471 2 9.33301 2Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66699 6.6665C6.21928 6.6665 6.66699 6.21879 6.66699 5.6665C6.66699 5.11422 6.21928 4.6665 5.66699 4.6665C5.11471 4.6665 4.66699 5.11422 4.66699 5.6665C4.66699 6.21879 5.11471 6.6665 5.66699 6.6665Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3337 11.3335L10.899 7.58663C10.7512 7.4253 10.5424 7.3335 10.3237 7.3335C10.1166 7.3335 9.91806 7.41576 9.77173 7.5621L6.66699 10.6668L5.22651 9.22636C5.08169 9.0815 4.88527 9.00016 4.68045 9.00016C4.45987 9.00016 4.24981 9.0945 4.10327 9.25936L1.66699 12.0002",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIc);
export default __webpack_public_path__ + "static/media/gallery_ic.cee2871af1e7e8b541ff8f4614cc3888.svg";
export { ForwardRef as ReactComponent };